import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface WeatherForecastDay {
  date: string;
  weatherCode: number;
  category: 'sunny' | 'cloudy' | 'rainy' | 'snowy';
  label: string;
  icon: string;
  tempMax: number | null;
  tempMin: number | null;
  precipitationProbability: number | null;
  isBadWeather: boolean;
  suggestion: string | null;
}

interface UseWeatherForecastOptions {
  enabled?: boolean;
}

export const useWeatherForecast = (options: UseWeatherForecastOptions = {}) => {
  const { enabled = true } = options;

  const query = useQuery({
    queryKey: ['weather-forecast'],
    queryFn: async (): Promise<WeatherForecastDay[]> => {
      const { data, error } = await supabase.functions.invoke('get-weather-forecast');
      if (error) throw error;
      return data?.forecast || [];
    },
    enabled,
    staleTime: 30 * 60 * 1000, // 30 min cache
    refetchOnWindowFocus: false,
  });

  return {
    forecast: query.data || [],
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};
